import { Button, ButtonGroup } from "react-bootstrap";
import {
  Control,
  FieldPath,
  FieldValues,
  useController,
} from "react-hook-form";

const unselectedStyle = {
  opacity: 0.6,
  textDecoration: "line-through",
  color: "#6c757d",
} as const;

const AbsolutePercentToggle = <TForm extends FieldValues>({
  name,
  control,
}: {
  name: FieldPath<TForm>;
  control: Control<TForm>;
}) => {
  const {
    field: { onChange, value },
  } = useController({
    name,
    control,
  });

  return (
    <ButtonGroup>
      <Button
        variant={value === "percent" ? "primary" : "light"}
        style={value !== "percent" ? unselectedStyle : undefined}
        aria-pressed={value === "percent"}
        onClick={() => onChange("percent")}
      >
        %
      </Button>
      <Button
        variant={value === "absolute" ? "primary" : "light"}
        style={value !== "absolute" ? unselectedStyle : undefined}
        aria-pressed={value === "absolute"}
        onClick={() => onChange("absolute")}
      >
        $
      </Button>
    </ButtonGroup>
  );
};

export default AbsolutePercentToggle;
